import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { WorkspaceSelectCard } from '@/components/auth/WorkspaceSelectCard'
import { useAuthStore } from '@/stores/auth.store'

export function WorkspaceSelectPage() {
  const navigate = useNavigate()
  const { userId } = useAuthStore()

  useEffect(() => {
    if (!userId) {
      navigate('/login', { replace: true })
    }
  }, [userId, navigate])

  if (!userId) {
    return null
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-neutral-50 px-4">
      <WorkspaceSelectCard />
    </div>
  )
}